import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/main/pages/administration-area/services/user.service';
import { LoaderService } from '../../services/loaderService.service';
import { LocalAccountService } from '../../services/localAccount.service';

@Component({
  selector: 'app-professor-categories-legend',
  templateUrl: './professor-categories-legend.component.html',
  styleUrls: ['./professor-categories-legend.component.scss']
})
export class ProfessorCategoryLegendComponent implements OnInit {

  professorCategories: any[];
  title: string;
  userLogged: any;
  label: string;

  constructor(
    //
    private loaderService: LoaderService,
    private userService: UserService,
    private localAccountService: LocalAccountService
  ) {
    this.title = 'Legenda Categorie Formatore';
    this.professorCategories = [];
    this.label = 'AD-HOC';
  }

  async ngOnInit() {
    await this.initializeProfessorCategories();
  }

  async initializeProfessorCategories() {
    this.loaderService.showLoader();
    await this.userService.retrieveProfessorCatories()
      .then(async (res: any) => {
        await this.localAccountService.getAccount()
          .then((res: any) => {
            this.userLogged = res;
            if (this.userLogged) {
              let customCategory: any = {};
              if (this.userLogged.hourlyCost) {
                customCategory.readableName = this.label;
                customCategory.hourlyCost = this.userLogged.hourlyCost;
              }
              if (this.userLogged.maxNumStudents) {
                customCategory.readableName = this.label;
                customCategory.maxNumStudents = this.userLogged.maxNumStudents;
              }
              if (customCategory.readableName) {
                this.professorCategories.push(customCategory);
              }
            }
          }).catch((err) => {
            console.error(err);
          });
        this.professorCategories = this.professorCategories.concat(res.payload);
      }).catch((err) => {
        console.error(err);
      }).finally(() => {
        this.loaderService.hideLoader();
      });
  }
}